<template>
<v-row v-if="hasActiveFilter">
  <v-col>
    <div class="d-flex align-center">
      <div class="text-caption mr-4">{{$t('projects.ProjectsActiveFilters.activeFilters')}}</div>
      <template v-if="hasMetadataFilter">
        <v-chip v-for="([key]) in activeMetadataFilters"
                :key="key"
                class="mr-4" 
                closable
                close-icon="fal fa-times"
                @click:close="removeMetadataFilter(key)">
          {{ computedMetadataLabel(key) }}
        </v-chip>
      </template>
      <v-chip v-if="filtersPane.filters.creationDate.length > 0"
              class="mr-4"
              closable
              close-icon="fal fa-times"
              @click:close="removeCreationDateFilter"
      >
        {{ $t('projects.ProjectsActiveFilters.creationDateFilter') }}
      </v-chip>
      <v-chip v-if="filtersPane.filters.dueDate.length > 0"
              class="mr-4"
              closable
              close-icon="fal fa-times"
              @click:close="removeDueDateFilter"
      >
        {{ $t('projects.ProjectsActiveFilters.dueDateFilter') }}
      </v-chip>
      <v-chip v-if="filtersPane.filters.selectedLabels.length > 0"
              class="mr-4"
              closable
              close-icon="fal fa-times"
              @click:close="removeSelectedLabelsFilter"
      >
        {{ $t('projects.ProjectsActiveFilters.selectedLabelsFilter') }}
      </v-chip>
      <v-chip v-if="filtersPane.filters.projectType.length > 0"
              class="mr-4"
              closable
              close-icon="fal fa-times"
              @click:close="removeProjectTypeFilter"
      >
        {{ $t('projects.ProjectsActiveFilters.projectTypeFilter') }}
      </v-chip>
      <v-chip v-if="filtersPane.filters.role.length > 0"
              class="mr-4"
              closable
              close-icon="fal fa-times"
              @click:close="removeRoleFilter"
      >
        {{ $t('projects.ProjectsActiveFilters.roleFilter') }}
      </v-chip>
    </div>
  </v-col>
</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProjectsActiveFilters',
  computed: {
    ...mapState('rooms', ['filtersPane']),
    hasActiveFilter () {
      return this.filtersPane.filters.creationDate.length > 0 ||
        this.filtersPane.filters.dueDate.length > 0 ||
        this.filtersPane.filters.selectedLabels.length > 0 ||
        this.filtersPane.filters.projectType.length > 0 ||
        this.filtersPane.filters.role.length > 0 ||
        this.hasMetadataFilter
    },
    hasMetadataFilter () {
      return this.filtersPane.filters.metadata && Object.keys(this.filtersPane.filters.metadata).some(key => this.filtersPane.filters.metadata[key].length > 0)
    },
    activeMetadataFilters () {
      return Object.entries(this.filtersPane.filters.metadata).filter(([, v]) => v.length > 0)
    },
    computedMetadataLabel () {
      return (key) => {
        const metadata = this.$store.state.rooms.existingMetadata[key]
        return metadata ? metadata.label : this.removeMetadataKeyUnderscore(key)
      }
    },
  },
  methods: {
    removeCreationDateFilter () {
      this.$store.commit('rooms/DELETE_CREATION_DATE_FILTER')
    },
    removeDueDateFilter () {
      this.$store.commit('rooms/DELETE_DUE_DATE_FILTER')
    },
    removeSelectedLabelsFilter () {
      this.$store.commit('rooms/DELETE_SELECTED_LABELS_FILTER')
    },
    removeProjectTypeFilter () {
      this.$store.commit('rooms/DELETE_PROJECT_TYPE_FILTER')
    },
    removeRoleFilter () {
      this.$store.commit('rooms/DELETE_ROLE_FILTER')
    },
    removeMetadataFilter (key) {
      this.$store.commit('rooms/DELETE_METADATA_FILTER', key)
    },
    removeMetadataKeyUnderscore (key) {
      return key?.replace(/_/g, ' ').trim().slice(0, -1) + 'd'
    },
  },
}
</script>
